import React, { useState, useEffect } from 'react';
import './HomeComponents.css';

function AdBannerSlider({ banners }) {
  const [currentBanner, setCurrentBanner] = useState(0);
  
  // Auto-rotate banners every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBanner(prev => (prev + 1) % banners.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [banners.length]);
  
  // Handle manual banner change
  const goToBanner = (index) => {
    setCurrentBanner(index);
  };
  
  // Prevent rendering if no banners available
  if (!banners || banners.length === 0) {
    return null;
  }
  
  return (
    <div className="ad-banner-slider">
      <div className="banner-container">
        {banners.map((banner, index) => (
          <div 
            key={banner.id} 
            className={`banner-slide ${index === currentBanner ? 'active' : ''}`}
          >
            <a href={banner.link} className="banner-link">
              <img 
                src={banner.imageUrl} 
                alt={banner.altText} 
                className="banner-image"
              />
            </a>
          </div>
        ))}
      </div>
      
      <div className="banner-indicators">
        {banners.map((banner, index) => (
          <button 
            key={`indicator-${banner.id}`}
            className={`indicator ${index === currentBanner ? 'active' : ''}`}
            onClick={() => goToBanner(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default AdBannerSlider; 